/* Local preview helpers. Original uploaded artwork is never modified. */
window.nepsLogoTools = (() => {
  function removeBackground(image, tolerance) {
    const {data, width, height} = image;
    const count = width * height;
    const output = new Uint8ClampedArray(data);
    // Use the top-left pixel as the background sample; only remove connected edges.
    const background = [data[0], data[1], data[2]];
    const seen = new Uint8Array(count), queue = new Int32Array(count);
    let head = 0, tail = 0;
    const visit = index => {
      if (index < 0 || index >= count || seen[index]) return;
      seen[index] = 1;
      const offset = index * 4;
      if (data[offset + 3] < 20 || background.every((value, channel) => Math.abs(data[offset + channel] - value) <= tolerance)) {
        queue[tail++] = index;
      }
    };
    for (let x = 0; x < width; x++) { visit(x); visit((height - 1) * width + x); }
    for (let y = 0; y < height; y++) { visit(y * width); visit(y * width + width - 1); }
    while (head < tail) {
      const index = queue[head++], x = index % width;
      output[index * 4 + 3] = 0;
      if (x > 0) visit(index - 1);
      if (x + 1 < width) visit(index + 1);
      if (index >= width) visit(index - width);
      if (index + width < count) visit(index + width);
    }
    return {data: output, width, height};
  }
  function dominantColour(data) {
    const buckets = new Map();
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 128) continue;
      const key = [data[i], data[i + 1], data[i + 2]].map(value => value >> 4).join(',');
      const item = buckets.get(key) || {count: 0, sums: [0, 0, 0]};
      item.count++;
      item.sums.forEach((_, c) => { item.sums[c] += data[i + c]; });
      buckets.set(key, item);
    }
    const largest = Array.from(buckets.values()).sort((a, b) => b.count - a.count)[0];
    return largest ? '#' + largest.sums.map(sum => Math.round(sum / largest.count).toString(16).padStart(2, '0')).join('') : '#000000';
  }
  return {removeBackground, dominantColour};
})();
